module.exports = __webpack_public_path__ + "static/media/brake-repair.bc0e20ca.svg";